var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 40",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.364 36.58a3.42 3.42 0 1 0 6.84 0 3.42 3.42 0 0 0-6.84 0Zm9.448-12.913c4.813-2.65 7.257-6.493 7.257-11.419C27.07 3.79 20.397 0 13.785 0 7.345 0 .5 4.68.5 13.354a3.321 3.321 0 0 0 6.642 0c0-4.613 3.444-6.712 6.643-6.712 2.48 0 6.642.728 6.642 5.606 0 1.73-.455 3.75-3.816 5.603-2.285 1.252-6.148 4.504-6.148 8.718a3.321 3.321 0 1 0 6.643 0c0-.617 1.312-2.135 2.706-2.902Z",
    fill: "#fff"
  })));
};
export default SvgQuestion;